import type { CSSProperties } from 'react';

export const DEFAULT_BORDER_COLOR = '#880C0C';
export const MOBILE_BREAKPOINT = 900;

// Base print mode styles without border (border applied per entity type)
const basePrintModeStyles: CSSProperties = {
  width: '2.5in',
  height: '3.5in',
  minWidth: '2.5in',
  minHeight: '3.5in',
  maxWidth: '2.5in',
  maxHeight: '3.5in',
  display: 'flex',
  flexDirection: 'column',
  margin: '0',
  background: '#fff',
  color: '#000',
  borderRadius: '6px',
  padding: '0.0833in',
  boxSizing: 'border-box',
  pageBreakInside: 'avoid',
  overflow: 'hidden',
};

export const PRINT_MODE_STYLES: CSSProperties = {
  ...basePrintModeStyles,
  border: `1px solid ${DEFAULT_BORDER_COLOR}`,
};

export const CLASS_PRINT_MODE_STYLES: CSSProperties = {
  ...basePrintModeStyles,
  border: `1px solid ${DEFAULT_BORDER_COLOR}`,
};
